import React, { useEffect, createContext, useState } from 'react';
import axios from 'axios';

export const KeywordsContext = createContext();

export const KeywordsProvider = ({children}) => {

   const [state, setState] = useState();

   useEffect(() => {
      axios
         .get(`https://www.paralele.me/api/keywords/index.php?lang=${window.languageInt}`)
         .then(res => res.data)
         .then(data => {
            setState(data)
         });
   }, []);

   if (!state) {
      return null;
   }
   
   return (
      <KeywordsContext.Provider value={state}>
         {children}
      </KeywordsContext.Provider>
   )
}